module.exports = __webpack_public_path__ + "img/P1010925.3e440c2c.jpg";